<template>
    <div>
        <mobile :max_price="max_price" :min_price="min_price" :get_filter="get_filter" @change="change"></mobile>
        <desktop :categories="categories" :title="title" :max_price="max_price" :min_price="min_price" :get_filter="get_filter" @change="change"></desktop>
    </div>
</template>

<script>
import mobile from "./filter_flow_parts/Mobile";
import desktop from "./filter_flow_parts/Desktop";
import filter from "./../mixins/filter";

export default {
    components: {
        mobile,
        desktop
    },
    mixins: [
        filter
    ]
}
</script>
